export default __webpack_public_path__ + "static/media/maintenance_illustration.0da740fe.png";